import React, { Component } from 'react';
import Switch from '../../../Part_Sample/Switch';

export default class Rent_Signal extends Component {
	constructor(props) {
		super(props);

		this.state = {

		}
	}

	render() {
		return (
			<div id='rent_signal' style={this.props.container_style}>
				<div style={{}}>
					<span className="header">{this.props.receiver.getString('rent_signal')}</span>
				</div>

				<div id='unrent_rcp' style={{ marginTop: 20, marginBottom: 10, marginLeft: 10 }}>
					<div style={{ display: 'inline-block', width: this.props.width - 120 }}>
						<span className='title' style={{ fontSize: 20 }}>{this.props.receiver.getString('rem_rent_op')}</span>
					</div>
					<Switch style={{ display: 'inline-block', verticalAlign: 'top' }} is_enabled={this.props.ctrl_param.rem_rent_op} handleToggleSwitch={this.props.handleChangeRemRentOp} />
				</div>
			</div>
		)
	}
}